import { useParams } from 'react-router-dom';

export default function TestRoute() {
  const { city } = useParams<{ city: string }>();
  
  return (
    <div style={{ padding: '20px', backgroundColor: 'lightgreen', minHeight: '100vh' }}>
      <h1 style={{ color: 'red', fontSize: '32px' }}>TEST ROUTE WORKS!</h1>
      <p style={{ fontSize: '20px' }}>City parameter: {city || 'NO CITY PARAM'}</p>
      <p>URL: {window.location.href}</p>
      <p>useParams result: {JSON.stringify(useParams())}</p>
    </div>
  );
}